import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProtectedPage } from '~/src/components/templates'
import { CurrencySettingsForm } from '~/src/components/pages/SettingCurrency/components/CurrencySettingForm'
import { settingCurrencyRepository } from '~/src/repositories'
import { ICurrency } from '~/src/repositories/SettingCurrency/models/SettingCurrency'
import { useMessage } from '~/src/hooks'
import { FormProvider, useForm } from 'react-hook-form'
import useSWR from 'swr'

type IPostBody = {
  baseCurrencyId: number
  currencyId: number
  rate: number
}[]

export const CurrencySetting: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const [baseCurrency, setBaseCurrency] = useState<{id: number, name: string}|undefined>(undefined)
  const [currencies, setCurrencies] = useState<ICurrency[]>([])
  const { handleOpenWithErrorMessage, handleOpenWithSuccessMessage } = useMessage()

  const { data, error } = useSWR('currencies', () => settingCurrencyRepository.getCurrencies())
  useEffect(() => {
    if (error) {
      handleOpenWithErrorMessage(error.message)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])
  useEffect(() => {
    if (data && data.data.length > 0) {
      setCurrencies(data.data)
      setBaseCurrency(data.data[0].baseCurrency)
    }
  }, [data])

  const [isPatch, setIsPatch] = useState<boolean>(false)
  const methods = useForm()
  const onSubmit = async (formData: any) => {
    setIsPatch(true)
    const patchBody = Object.keys(formData).reduce((body: IPostBody, currencyName: string) => {
      const currency = currencies.find(
        (currency: ICurrency) => currencyName === currency.currency.name
      )

      body.push({
        baseCurrencyId: currency.baseCurrency.id as number,
        currencyId: currency.currency.id as number,
        rate: parseFloat(formData[currencyName]),
      })

      return body
    }, [] as IPostBody)

    try {
      await settingCurrencyRepository.patchCurrencies(patchBody)
      handleOpenWithSuccessMessage('Success!!')
    } catch (e: any) {
      handleOpenWithErrorMessage(e.message)
    } finally {
      setIsPatch(false)
    }
  }

  return (
    <ProtectedPage pageTitle={t('currency.key_currency_setting')}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          {baseCurrency && currencies.length > 0 && (
            <CurrencySettingsForm baseCurrency={baseCurrency} currencies={currencies} isPatch={isPatch} />
          )}
        </form>
      </FormProvider>
    </ProtectedPage>
  )
}
